import { mapGetters, mapState } from 'vuex';
import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('dashboard', ['mySharesCount']),
    ...mapState('dashboard', [
      'selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter',
    ]),
    mainClassName() {
      return 'market-filters-dashboard';
    },
    menuClassModifier() {
      return {
        'market-filters-dashboard__menu': true,
        'market-filters-dashboard__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
    orderMenuName() {
      return this.isLayoutMobile ? this.selectedOrder.name : this.selectedOrder.fullName;
    },
  },
  methods: {
    dashOrderSelected(sort) {
      return this.selectedOrder.sort === sort;
    },
  },
  created() {
    this.isDashboardOpen = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-dashboard/market-filters-dashboard.js